/**
 * 销售指标统计 - 销售顾问
 */
export default {
  field_from_api: {
    booked: {
      name: '预约到店'
    },
    reception: {
      name: '接待量'
    },
    new_reception: {
      name: '新增接待'
    }
  },
  getData (params = {}) {
    this.$rest.dataAnalysis.getSaleQuotaAnalysis(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
